import { render } from "./RangeWeight.vue?vue&type=template&id=2825b41b"
import script from "./RangeWeight.vue?vue&type=script&lang=js"
export * from "./RangeWeight.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__